import { render, staticRenderFns } from "./ProjectEvents.vue?vue&type=template&id=c0319722&"
import script from "./ProjectEvents.vue?vue&type=script&lang=js&"
export * from "./ProjectEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports